'use es6';

import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import UILink from 'UIComponents/link/UILink';
import { jsx as _jsx } from "react/jsx-runtime";
class WorkflowLink extends PureComponent {
  render() {
    const {
      emailSubject,
      portalId,
      workflowId
    } = this.props;
    const workflowHref = `/workflows/${portalId}/platform/flow/${workflowId}/edit/`;
    return /*#__PURE__*/_jsx(UILink, {
      className: "is--text--demibold",
      href: workflowHref,
      target: "_blank",
      children: emailSubject
    });
  }
}
WorkflowLink.displayName = 'WorkflowLink';
WorkflowLink.propTypes = {
  emailSubject: PropTypes.string.isRequired,
  portalId: PropTypes.number.isRequired,
  workflowId: PropTypes.number.isRequired
};
export default WorkflowLink;